<div class="c-soon">
  <div class="row">
    <div class="col-12">
      <img :src="require('@/assets/icons/sidebars/no-result.svg')" alt="" />
    </div>
  </div>
  <div class="c-soon-title">
    <span class="name">{{ $t('errorSoon') }}</span>
    <span class="desc">{{ $t('errorSoonMessage') }}</span>
  </div>
</div>
<!-- Sorry, there are no results for this search. Please try another phrase -->